import DropdownMenuItemContentRadio from "@excalidraw/excalidraw/components/dropdownMenu/DropdownMenuItemContentRadio";
import { emptyIcon } from "@excalidraw/excalidraw/components/icons";

import { useDrawolaT } from "../storage/i18n";

import {
  useMinimapPreference,
  type MinimapPreference,
} from "./useMinimapPreference";

export const MinimapPreferenceItem = () => {
  const t = useDrawolaT();
  const [preference, setPreference] = useMinimapPreference();

  const choices: Array<{
    value: MinimapPreference;
    label: string;
    ariaLabel: string;
  }> = [
    {
      value: "disabled",
      label: t("minimap.off"),
      ariaLabel: t("minimap.offAria"),
    },
    {
      value: "auto",
      label: t("minimap.auto"),
      ariaLabel: t("minimap.autoAria"),
    },
    {
      value: "always",
      label: t("minimap.on"),
      ariaLabel: t("minimap.onAria"),
    },
  ];

  return (
    <DropdownMenuItemContentRadio<MinimapPreference>
      name="drawola-minimap-pref"
      icon={emptyIcon}
      value={preference}
      onChange={(next) => setPreference(next)}
      choices={choices}
    >
      {t("minimap.menuEntry")}
    </DropdownMenuItemContentRadio>
  );
};

MinimapPreferenceItem.displayName = "MinimapPreferenceItem";
